import stCss from '../../st-css';
import {styleProps, textShorthandProps} from 'st-css';
import { spacingShorthandProps, visibilityShorthandProps } from 'st-css';

export const Divider = stCss.canonize('div')({
    width: '0px',
    border: '1px solid #0085FF',
    height: '64px',
    mx: '16px'
}, styleProps(textShorthandProps, spacingShorthandProps, visibilityShorthandProps));